<script lang="ts">
    import Semester from "../presentational/Semester.svelte";
    import {Modal} from 'svelma';
    import {writable} from "svelte/store";
    import Manager from "../../application/SyllabusManager/models/Manager.ts";
    import ModalController from "./ModalController.svelte";
    import ClickIcon from "../presentational/ClickIcon.svelte";
    import {_} from "svelte-i18n";

    export let snapshots;
    export let targetId = writable(null);
    export let selected;
    export let option;
    export let languages;

    let manager: Manager = new Manager(snapshots[$selected], $option);
    let modalActive = false;
    let modalData = writable(null);
    let modalType = writable(null);

    $: {manager = new Manager(snapshots[$selected], $option)}

    function handleClick(event) {
        $modalData = event.detail.data;
        $modalType = event.detail.type;
        modalActive = true;
    }
</script>

<div class="background"></div>
<div class="page">
    <div class="modules columns is-hidden-mobile">
        {#each manager.syllabusManager.getModules() as module}
            <div class="column module">
                <div class="title is-6 has-text-centered">
                    {module._nameHu}
                    <ClickIcon data={module} type="module" on:infoClick={handleClick}/>
                </div>
            </div>
        {/each}
    </div>
    <div class="semesters">
        {#each manager.syllabusManager.getSemesters() as semester, i}
            <div class="semesterModule is-flex">
                {semester.semesterIndex}. {$_('panel.semester')}
                <ClickIcon data={semester} type="semester" on:infoClick={handleClick}/>
            </div>
            <Semester on:cardClick={handleClick} languages={languages} modules={semester._subjects} manager={manager} targetId={targetId}/>
        {/each}
    </div>
</div>
<Modal bind:active={modalActive} func={null}>
    <ModalController languages={languages} data={modalData} type={modalType} manager={manager}/>
</Modal>

<style>
    .module{word-break: keep-all}
    .semesterModule{
        background-color: rgba(241, 239, 239, 0.14);
        width: 180px;
        height: 40px;
        line-height: 30px;
        padding: 2px 0 2px 10px;
        margin: 10px 0 10px 0;
        border-radius: 0 5px 5px 0;
        border-top: 1px solid rgba(248, 246, 246, 0.4);
    }
</style>